// extracted by mini-css-extract-plugin
export default {"heading":"BannerSetting_heading__AlEnh","wrapper":"BannerSetting_wrapper__T3qko"};